/**
 * Text color classes for HTTP method labels (colored text only).
 * Must match utilities defined in index.css — this project ships a hand-picked
 * subset of Tailwind-like classes, not the full Tailwind scanner.
 */
export function httpMethodLabelClass(method) {
  const m = typeof method === 'string' ? method.toUpperCase() : method;
  switch (m) {
    case 'GET':
      return 'text-green-600';
    case 'POST':
      return 'text-yellow-600';
    case 'PUT':
      return 'text-orange-600';
    case 'DELETE':
      return 'text-red-600';
    case 'PATCH':
      return 'text-purple-700';
    case 'OPTIONS':
      return 'text-gray-500';
    case 'HEAD':
      return 'text-blue-400';
    default:
      return 'text-gray-500';
  }
}
